export const DESCRIPTION_TEXT_MAX_CHAR = 1500;
export const DESCRIPTION_TEXT_ROWS = 3;
export const ADDITIONAL_INFO_TEXT_MAX_CHAR = 1500;
export const ADDITIONAL_INFO_TEXT_ROWS = 3;
export const SHORT_DESCRIPTION_TEXT_MAX_CHAR = 60;
export const SHORT_DESCRIPTION_TEXT_ROWS = 1;
// A note for the picker is read standing in a freezer, in gloves: one line, not a story.
export const PICK_NOTE_TEXT_MAX_CHAR = 120;
